module.exports = __webpack_public_path__ + "static/img/4.cf9bb8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/realisations/croixDallageAssainissement/4.jpg
// module id = MERU
// module chunks = 0